export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.527 5.782a.745.745 0 01-1.054 0L0 1.309 1.054.255 5 4.2 8.946.255 10 1.309 5.527 5.782z\" fill=\"#ff00cb\"/>",
  "attrs": {
    "width": "12",
    "height": "12",
    "viewBox": "0 0 10 6",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};